{
  "HeaderSidebar_ExpandMenu": "Expand Menu (Ctrl + ])",
  "HeaderSidebar_CollapseMenu": "Collapse Menu (Ctrl + [)",
  "HeaderSidebar_PinMenu": "Pin Menu Expanded",
  "HeaderSidebar_UnpinMenu": "Unpin Menu",
  "HeaderSidebar_Apps": "Apps",
  "NAME": "HeaderSidebar"
}